import React from 'react';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { GlobalViewTaxForm } from './global-viewtaxform';
import { ViewTaxFormPropTypes } from '../../shapes';

const { CountryCode } = Constants;

export const MYTaxViewTaxForm = props => (
  <GlobalViewTaxForm
    {...props}
    showTaxCert={false}
    countryCode={CountryCode.MY}
  />
);

MYTaxViewTaxForm.propTypes = ViewTaxFormPropTypes;
